
import { Component, Watch, VModel, Mixins } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'
import { deserialise } from 'kitsu-core'

import MixinInterface from '@/_mixins/index'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin'

import { getRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'
import { initDialog } from '@/utils/dialog'

import SearchCompanyByOrgNumDialog from '@/views/Company/dialogs/searchCompanyByOrgNum.vue'
import Dialog from '@/components/Dialog/Dialog.vue'

@Component({
    inheritAttrs: false,
    mixins: [CompanyInfoMixin],
    components: { Dialog },
})
export default class AutocompleteCompany extends Mixins<MixinInterface>(CompanyInfoMixin) {
    @VModel() company!: null | Record<string, any> | Array<any>

    // COMPANY AUTOCOMPLETE
    loading = false
    offset = 0
    limit = 10
    searchTerm = ''
    companies = [] as Array<any>

    @Watch('searchTerm')
    initLoading() {
        if (this.searchTerm?.length > 1) this.loading = true
    }

    @Debounce(600)
    @Watch('company', { deep: true })
    @Watch('searchTerm')
    async initSearchCompanies() {
        this.loading = true
        if (this.searchTerm?.length > 1) {
            await this.searchCompanies()
        } else {
            this.setInitValues()
        }

        this.loading = false
    }

    async searchCompanies($state = null as any) {
        try {
            this.loading = true

            const { data } = await getRequest(
                getURL({
                    path: `companies`,
                    base: process.env.VUE_APP_COMPANY_BASE_URL,
                    params: {
                        skipLinks: '',
                        'filter[searchTerm]': this.searchTerm,
                    },
                })
            )

            const newCompanies = deserialise(data).data

            this.offset += this.limit

            if ($state) {
                if (newCompanies.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }

            this.companies = [...this.companies, ...newCompanies]
        } finally {
            this.loading = false
        }
    }

    setInitValues() {
        if (this.company) {
            if (this.lodash.isArray(this.company)) {
                this.companies = this.company
            } else {
                this.companies = [this.company]
            }
        } else {
            this.companies = []
        }
    }

    nameWithOrgNum(val) {
        if (!val || !val.name) return ''
        const formatedOrgNumber = val.orgNo
            ? `(${val.nationality ? this.formatOrgNumber(val.orgNo, val.nationality) : val.orgNo})`
            : null
        return `${val.name} ${formatedOrgNumber ? formatedOrgNumber : ''}`
    }

    mounted() {
        this.setInitValues()
    }

    async initAddCompany() {
        const res = await initDialog(SearchCompanyByOrgNumDialog, {})

        if (res) {
            if (this.lodash.isArray(this.company)) {
                const index = this.company.findIndex((comp) => comp.id == res.id)
                if (index == -1) {
                    this.company.push(res)
                }
            } else {
                this.company = res
            }
            this.setInitValues()
        }
    }
}
